import { useFrame } from "@react-three/fiber";

import { FrontSide, Mesh } from "three";

import { useTheme } from "@mui/material";
import { Canvas } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
import { degToRad } from "three/src/math/MathUtils";
import { GridShaderMaterial } from "./GridShaderMaterial";

export const BlackHole = () => {
  return (
    <Canvas
      style={{
        maskImage:
          "linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.5) 8%, rgba(0,0,0,1) 35%, rgba(0,0,0,1) 70%, rgba(0,0,0,0) 100%)",
        height: "100%",
        width: "100%",
      }}
      camera={{
        rotation: [degToRad(5), degToRad(0), degToRad(0)],
        position: [0, -0.1, 8],
        near: 0.01,
        far: 1000,
        fov: 55,
      }}
      gl={{
        powerPreference: "high-performance",
        antialias: true,
        alpha: true,
      }}
    >
      <BlackHoleScene />
    </Canvas>
  );
};

const BlackHoleScene = () => {
  const meshRef = useRef<Mesh>(null);
  const theme = useTheme();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useFrame((_state, delta) => {
    if (meshRef.current) {
      meshRef.current.rotation.z -= delta * (isMobile ? 0.0095 : 0.001);
    }
  });

  return (
    <>
      <ambientLight intensity={1} color={theme.palette.yellow.main} />
      <directionalLight
        position={[0, 0, -24]}
        intensity={0.75}
        color={theme.palette.yellow.main}
      />
      <mesh
        ref={meshRef}
        position={[0, -2, 0]}
        rotation={[degToRad(135), degToRad(0), degToRad(0)]}
      >
        <torusGeometry args={[9, 8, 210, 210]} />
        <GridShaderMaterial
          animationSpeed={0.000175}
          baseWidth={0.025}
          maxWidth={0.065}
          opacity={0.35}
          gridSize={50}
          grid={0.3}
        />
      </mesh>

      <mesh
        rotation={[degToRad(135), degToRad(0), degToRad(0)]}
        position={[0, -2, 0]}
      >
        <torusGeometry args={[8.985, 7.985, 210, 210]} />
        <meshPhongMaterial
          emissiveIntensity={1.1}
          specular={"#000000"}
          emissive={"#053744"}
          transparent={false}
          color={"#043d3e"}
          side={FrontSide}
          shininess={4}
        />
      </mesh>
    </>
  );
};
